import { idExist as idExistHelper } from "../helpers/exist";

const idExist = {
  install: (Vue) => {
    Vue.prototype.$idExist = (id) => idExistHelper(id);
  },
};

export default idExist;
